export enum RequestMethod{
    GET = 'GET',
    POST = 'POST',
    PITCH = 'PATCH',
    DELETE = 'DELETE',
    PUT = 'PUT'
}

export enum ToastSeverity {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warining'
}